module.exports = __webpack_public_path__ + "bg-pricing-small--ba458abb.png";


//////////////////
// WEBPACK FOOTER
// ./_source/img/pricing/bg-pricing-small.png
// module id = 38
// module chunks = 0